module.exports = __webpack_public_path__ + "media/images/shared/icon_arrow_right_black-3ad6ae734ea8ff72ab75cc59f020db1a.png";